import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock'

export default () => {
  const containers = document.querySelectorAll('.js-popup')

  if (containers.length < 1) return
  ;[...containers].forEach(container => {
    const trigger = container.querySelector('.js-popup-click')
    const close = container.querySelector('.js-popup-close')
    const target = container.querySelector('.js-popup-target')

    trigger.addEventListener('click', e => {
      target.classList.add('active')
      window.dataLayer = window.dataLayer || []
      let data = {
        event: 'popupOpen',
        page: container.querySelector('input[name="page"]').value
      }

      window.dataLayer.push(data)

      disableBodyScroll(target)
    })

    close.addEventListener('click', e => {
      target.classList.remove('active')
      e.stopPropagation()
      enableBodyScroll(target)
      window.dataLayer = window.dataLayer || []
      let data = {
        event: 'popupClose',
        page: container.querySelector('input[name="page"]').value
      }

      window.dataLayer.push(data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Popup.js